// extracted by mini-css-extract-plugin
module.exports = {"attention":"style_attention__NT6FD"};